import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { properties } from 'src/environments/properties';

@Component({
  selector: "app-monthly-plan",
  templateUrl: "./monthly-plan.component.html",
  styleUrls: ["./monthly-plan.component.scss"],
})
export class MonthlyPlanComponent implements OnInit {
  @Input() monthlyPlan: any;
  @Output() changePlan = new EventEmitter();
  @Input() currentEnvironment;
  properties = properties;
  monthlyText = properties.monthlyPlan.months;
  SNAP_MONTHLY_PLAN_DESCRIPTION: string = "Requires yearly verification or is automatically cancelled.</br>Discount plan available for up to 24 months";
  planDescriptionText = properties.monthlyPlan.autoRenew;
  SNAP = properties.planCard.SNAP;
  pricingDetailText: string = "";
  isSnapVerified: boolean = false;

  ngOnInit(): void {
    this.isSnapVerified = this.monthlyPlan?.promoCategory === this.SNAP ? true : false;

    this.checkMonthlyText();
    this.getPricingDetailText();
    this.getPlanDescriptionText();
  }

  changePlanType(code) {
    this.changePlan.emit(code);
    if (window["AB"] && window["AB"]["DATALAYER"]) {
      window["AB"]["DATALAYER"].analyticsSetLSFPUpdate("changePlanToMonthlyBtn");
    }
  }

  checkMonthlyText() {
    if (this.monthlyPlan && this.monthlyPlan.discountDuration && this.monthlyPlan.discountDuration > 1) {
      this.monthlyText = properties.monthlyPlan.months;
    } else {
      this.monthlyText = properties.changePlan.month;
    }
  }

  getPricingDetailText() {
    let pricingDetail = "";

    if (this.isSnapVerified) {
      pricingDetail = `<span><span class="sr-only">Discount Price</span>$${this.monthlyPlan.monthlyCost}</span> <s class="grey-strike-color"><span class="sr-only">Original Price</span>$${this.monthlyPlan.regularPlanPrice}</s>/month`;
    } else {
      pricingDetail = this.monthlyPlan?.pricingDetailLine1;
    }
    this.pricingDetailText = pricingDetail;
  }

  getPlanDescriptionText() {
    let planDescription = "";
    if (this.isSnapVerified) {
      planDescription = this.SNAP_MONTHLY_PLAN_DESCRIPTION;
    } else if (this.monthlyPlan?.discountDuration && this.monthlyPlan.promoCategory !== this.SNAP) {
      planDescription = `Auto-renews at ${this.monthlyPlan?.regularPlanPrice}/mo after ${this.monthlyPlan?.discountDuration} ${this.monthlyText}.`;
    } else {
      planDescription = properties.monthlyPlan.autoRenew;
    }
    this.planDescriptionText = planDescription;
  }
}
